import { AxisSide, type AxisSpec } from "../ChartSpec";

/** Left-side axes in spec order. More than one means the panel shows the metric picker. */
export function getLeftAxes(axes: AxisSpec[]): AxisSpec[] {
    return axes.filter((axis) => axis.side === AxisSide.Left);
}
